import {
  Typography,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useAptorApi } from '../../../../Api';
import { FormattedMessage, useIntl } from 'react-intl';
import { useIsMounted } from '../../../../Hooks/useIsMounted';
import { IGridQueryRequest, OrderDirection } from '../../../../Api/AptorApi';
import moment from 'moment';
import { Query } from '@material-table/core';
import { LawLink, MTable } from '../../../../Components';
import { UserContext } from '../../../../Context/UserContext/UserContext';
import { ChangeAcknowledgeDialog, ChangeAcknowledgeDialogTarget } from '../../Components/ChangeAcknowledgeDialog';

type UnacknowledgedChange = {
  id: number;
  number: string;
  effectiveFrom: Date;
  lawId: number;
  name: string;
  userId: number;
  userName: string;
  type: 'Law' | 'Requirement';
};

export const ChangeUnacknowledgedLaw = () => {
  const { api } = useAptorApi();
  const { formatMessage } = useIntl();
  const tableRef = React.useRef<any>(null);
  const { id } = useContext(UserContext);
  const isMounted = useIsMounted();
  const [selectedChangeTarget, setSelectedChangeTarget] = useState<ChangeAcknowledgeDialogTarget>();

  useEffect(() => {
    if (isMounted) {
      tableRef.current && (tableRef.current as any).onQueryChange();
    }
  }, [tableRef, isMounted]);

   const handleDataFetch = useCallback(
      async (query: Query<UnacknowledgedChange>) => {
        return await api.searchlawUnacknowledgedChanges<UnacknowledgedChange>({
          orderDirection: query.orderDirection === 'desc' ? OrderDirection.Descending : OrderDirection.Ascending,
          orderBy: query.orderBy !== undefined ? query.orderBy.field : 'effectiveFrom',
          page: query.page,
          pageSize: query.pageSize,
          search: query.search,
         filters: {
          complianceUsers: [id?.toString()],
        },
        }as unknown as IGridQueryRequest);
      },
      [api,id],
    );
  const renderDate = (date?: Date) => {
    return date ? moment(date).format('ll') : undefined;
  };

  const handleOpenChangeDialog = (row: UnacknowledgedChange) => {
    setSelectedChangeTarget(row);
  };

  const handleAcknowledge = async (target: ChangeAcknowledgeDialogTarget, comment: string, affect?: boolean) => {
    if (target.lawId) {
      await api.acknowledgeLawPortalLawChange(target.lawId, target.id, comment, affect);
    }
  };

  const refreshTable = () => {
    tableRef.current && (tableRef.current as any).onQueryChange();
  };

  return (
    <>
    <Card className='dashboar-unacknowledgedChange-card'>
      <CardHeader
        title={
          <Typography variant="h3">
            <FormattedMessage id="law-portal.statistics.sub-menu.changes.unacknowledged"></FormattedMessage>
          </Typography>
        }
        action={
          <LawLink
                    url="/law-portal/our-laws/unacknowledged"
                    urlText={formatMessage({ id: 'law-portal.dashboard.go-to-changes-to-acknowledge' })}
                    openInNewTab={false}
                  />
          // <Link to="/law-portal/our-laws/unacknowledged" style={{ textDecoration: 'none' }}>
          //   <Typography  color="primary" style={{display:'flex',alignItems:'center',gap:'5px'}}>
          //     <FormattedMessage id="law-portal.dashboard.go-to-changes-to-acknowledge"></FormattedMessage>
          //     {/* <ArrowForward /> */}
          //   </Typography>
          // </Link>
        }
      />
      <CardContent>
         <MTable
                tableRef={tableRef}
                columns={[
                  {
                    title: formatMessage({ id: 'law-portal.our-laws.table.law' }),
                    field: 'name',
                  },
                  {
                    title: formatMessage({ id: 'law-portal.statistics.table.number' }),
                    field: 'number',
                    render: (row) => (
                      <a
                        href={`/law-portal/our-laws/${row.lawId}/changes`}
                        onClickCapture={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          handleOpenChangeDialog(row);
                        }}
                        style={{
                          color: '#551a8b',
                          cursor: 'pointer',
                          font: 'inherit',
                          textDecoration: 'underline',
                        }}
                      >
                        {row.number}
                      </a>
                    ),
                  },
                  {
                    title: formatMessage({ id: 'law-portal.statistics.table.effectiveFrom' }),
                    field: 'effectiveFrom',
                    render: (row) => renderDate(row.effectiveFrom),
                  },
                ]}
                data={handleDataFetch}
                options={{ 
                  toolbar: false, 
                  pageSize: 5,
                  headerStyle: {
                    backgroundColor: '#f5f5f5'
                  }
                }}
              />
      </CardContent>
    </Card>
    <ChangeAcknowledgeDialog
      target={selectedChangeTarget}
      onClose={() => setSelectedChangeTarget(undefined)}
      onAcknowledged={refreshTable}
      onAcknowledge={handleAcknowledge}
    />
    </>
  );
};
